import { getGAIdAsync } from './StoreConfigManager.js';

const missedVirtualPagePaths = [];
const missedEvents = [];
let storeName = '';

export function setStoreName(name) {
    storeName = name;
}

export function sendMissedAnalyticsOnGALoaded(id) {
    missedVirtualPagePaths.forEach(element => {
        console.log('sending missed virtual page paths', element);
        window.gtag('config', id, { 'page_path': element });
    });

    missedEvents.forEach(element => {
        console.log('sending missed events', element);
        const category = element['event_category'];
        const action = element['event_action'];
        const label = element['event_label'];
        window.gtag('event', 'play', {
            'event_category': category,
            'event_action': action,
            'event_label': label
        });
    });
}

const AtLeastOnce = {
    EventCategory: 'At least once',
    Props: {
        MovedOnce: {
            EventAction: 'Moved once',
            EventLabel: 'Moved once',
            called: false
        },
        ProductHotspotOnce: {
            EventAction: 'Product hotspot once',
            EventLabel: 'Product hotspot once',
            called: false
        },
        BuyNowOnce: {
            EventAction: 'Buy now once',
            EventLabel: 'Buy now once',
            called: false
        },
        InteractedOnce: {
            EventAction: 'Interacted once',
            EventLabel: 'Interacted once',
            called: false
        }
    }
}

const Navigation = {
    EventCategory: 'Navigation',
    Props: {
        SceneLoaded: {
            EventAction: 'Scene loaded',
            EventLabel: ''
        },
        ArrowClicked: {
            EventAction: 'Arrow clicked',
            EventLabel: ''
        },
        NavigationMenuClicked: {
            EventAction: 'Navigation menu clicked',
            EventLabel: ''
        },
        GifNavigationClick: {
            EventAction: 'Artist sign clicked',
            EventLabel: '<action> <view name>'
        },
        NavigationMenuOptionClicked: {
            EventAction: 'Navigation menu option clicked',
            EventLabel: ''
        },
    }
}

const Custom = {
    EventCategory: 'Custom',
    Props: {
        MusicIconClicked: {
            EventAction: 'Music icon clicked',
            EventLabel: 'Music icon'
        },
        ArrowPanelClicked: {
            EventAction: 'Arrow panel',
            EventLabel: ''
        },
        RightArrowClicked: {
            EventAction: 'Right Arrow clicked',
            EventLabel: ''
        },
        LeftArrowClicked: {
            EventAction: 'Left Arrow clicked',
            EventLabel: ''
        },
    }
}

const Product = {
    EventCategory: 'Product',
    Props: {
        ProductHotspotClicked: {
            EventAction: 'Product hotspot clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        BuyNowClicked: {
            EventAction: 'Buy now clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        AddedProductToFavorite: {
            EventAction: 'Favorite added',
            EventLabel: '<Product name> - <SKU>'
        },
        RemovedProductFromFavorite: {
            EventAction: 'Favorite removed',
            EventLabel: '<Product name> - <SKU>'
        },
        SpinActivated: {
            EventAction: 'Spin Activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorActivated: {
            EventAction: 'Color selector activated',
            EventLabel: '<Product name> - <SKU>'
        },
        ColorSelectorOptionClicked: {
            EventAction: 'Color selector option clicked',
            EventLabel: '<Product name> - <Product color>'
        },
        SizeSelectorOptionClicked: {
            EventAction: 'Size selector option clicked',
            EventLabel: '<Product name> - <Product Size>'
        },
        ProductQuantitySelectorClicked: {
            EventAction: 'Quantity selector option clicked',
            EventLabel: '<product name> - <sku> - <action>'
        },
        AddToCartClicked: {
            EventAction: 'Add to cart clicked',
            EventLabel: '<Product name> - <Product Size>'
        },
        DetailsClicked: {
            EventAction: 'Details clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        ThumbnailClicked: {
            EventAction: 'Thumbnail clicked',
            EventLabel: '<Product name> - <SKU>'
        },
        VideoIconClicked: {
            EventAction: 'Video icon clicked',
            EventLabel: '<Product name> - <SKU>'
        }
    }
}

const Other = {
    EventCategory: 'Other',
    Props: {
        LogoClicked: {
            EventAction: 'Logo clicked',
            EventLabel: 'Logo clicked'
        },
        WelcomeTipsDismissed: {
            EventAction: 'Welcome tips dismissed',
            EventLabel: 'Welcome tips dismissed'
        },
        MusicButton: {
            EventAction: 'Music button',
            EventLabel: 'on / off'
        },
        MusicPlayerVolumeAdjust: {
            EventAction: 'Music button',
            EventLabel: 'Volume adjusted'
        },
        FacebookButton: {
            EventAction: 'Facebook button',
            EventLabel: 'Facebook button'
        },
        TwitterButton: {
            EventAction: 'Twitter button',
            EventLabel: 'Twitter button'
        },
        WhatsAppButton: {
            EventAction: 'WhatsApp button',
            EventLabel: 'WhatsApp button'
        },
        ObsessLogo: {
            EventAction: 'Obsess logo',
            EventLabel: 'Obsess logo'
        },
        BrandLogo: {
            EventAction: 'Brand logo',
            EventLabel: 'Brand logo'
        },
        Email: {
            EventAction: 'Email',
            EventLabel: 'Entered / skipped'
        },
        StoreSelectorIcon: {
            EventAction: 'Store selector icon clicked',
            EventLabel: ''
        },
        StoreSelectorOption: {
            EventAction: 'Store selector option clicked',
            EventLabel: '<store name>'
        },
        CartIconClicked: {
            EventAction: 'Cart icon clicked',
            EventLabel: '<Scene slug>'
        },
        PhotoBoothHotSpotClicked: {
            EventAction: 'Photo booth hotspot clicked',
            EventLabel: '<store name> - <view name>'
        },
        PhotoBoothSnapButtonClicked: {
            EventAction: 'Photo booth - snap button clicked',
            EventLabel: '<store name> - <view name>'
        },
        PhotoBoothDownloadButtonClicked: {
            EventAction: 'Photo booth - Download button clicked',
            EventLabel: '<store name> - <view name>'
        },
        PhotoBoothRetakeButtonClicked: {
            EventAction: 'Photo booth - Retake button clicked',
            EventLabel: '<store name> - <view name>'
        },
        PoweredByObsessClicked: {
            EventAction: 'Powered by Obsess clicked',
            EventLabel: 'Powered by Obsess'
        },
        ClickAnywhereToContinue: {
            EventAction: 'Click anywhere to continue - ',
            EventLabel: 'Screen click'
        }
    }
}

const Content = {
    EventCategory: 'Content',
    Props: {
        InSceneVideoClicked: {
            EventAction: 'In-scene video',
            EventLabel: '<video name>'
        },
        PopupVideoClicked: {
            EventAction: 'Pop-up video',
            EventLabel: '<video name>'
        },
        ImageClicked: {
            EventAction: 'Image',
            EventLabel: '<image name>'
        },
        TextClicked: {
            EventAction: 'Text',
            EventLabel: ''
        },
        LinkClicked: {
            EventAction: 'Link',
            EventLabel: '<target url>'
        },
        TextPopUpHotSpotClicked: {
            EventAction: 'Text hotspot clicked',
            EventLabel: '<title>'
        },
        TextPopUpButtonClicked: {
            EventAction: 'Text pop-up button clicked',
            EventLabel: '<store name> - <view name>'
        }
    }
}

const Cart = {
    EventCategory: 'Cart',
    Props: {
        CheckoutButtonClicked: {
            EventAction: 'Checkout button clicked',
            EventLabel: 'Checkout button clicked'
        },
        QuantitySelectorClicked: {
            EventAction: 'Quantity selector option clicked',
            EventLabel: '<product name> - <sku> - <action>'
        }
    }
}
function sendUserAction(eventCategory, eventAction, eventLabel) {
    const eventTag = {
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': storeName + ' - ' + eventLabel,
        'anonymize_ip': true,
        event_name: eventCategory,
        action: eventAction,
        label: eventLabel,
    };

    if(eventAction === 'Scene loaded'){
        eventTag['non_interaction'] = true;
    }
    if (!window.gtag) {
        console.log('no gtag');
        missedEvents.push(eventTag)
        return;
    }

    window.gtag('event', eventCategory, eventTag);
}

// At Least Once
export function MovedOnce() {
    let prop = AtLeastOnce.Props.MovedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ProductHotspotOnce() {
    let prop = AtLeastOnce.Props.ProductHotspotOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BuyNowOnce() {
    let prop = AtLeastOnce.Props.BuyNowOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

export function InteractedOnce() {
    let prop = AtLeastOnce.Props.InteractedOnce;
    if (prop.called) {
        return;
    }
    prop.called = true;
    sendUserAction(AtLeastOnce.EventCategory, prop.EventAction, prop.EventLabel);
}

// Navigation
export function NavigationMenuClicked(sceneName) {
    let prop = Navigation.Props.NavigationMenuClicked;
    let eventLabel = sceneName;
    sendUserAction(Navigation.EventCategory, prop.EventAction, eventLabel);
}

export function SceneLoaded(sceneId) {
    console.log('sceneloaded', sceneId);
    let prop = Navigation.Props.SceneLoaded;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + sceneId);
}

export function ArrowClicked(destinationSceneId) {
    let prop = Navigation.Props.ArrowClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, prop.EventLabel + destinationSceneId);
}

export function NavigationMenuOptionClicked(eventLabel) {
    let prop = Navigation.Props.NavigationMenuOptionClicked;
    sendUserAction(Navigation.EventCategory, prop.EventAction, eventLabel);
}

// Product
export function ProductHotspotClicked(sku, productName) {
    console.log('Product hotspot clicked:', productName, sku);
    let prop = Product.Props.ProductHotspotClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function BuyNowClicked(sku, productName) {
    console.log('Buy now clicked:', productName, sku);
    let prop = Product.Props.BuyNowClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function SpinActivated(sku, productName) {
    console.log('Spin Activated:', productName, sku);
    let prop = Product.Props.SpinActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function ColorSelectorActivated(sku, productName) {
    let prop = Product.Props.ColorSelectorActivated;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`)
}

export function ColorSelectorOptionClicked(productColor, productName) {
    let prop = Product.Props.ColorSelectorOptionClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${productColor}`)
}

export function SizeSelectorOptionClicked(productName, sku, productSize) {
    let prop = Product.Props.SizeSelectorOptionClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku} - ${productSize}`)
}

export function ProductQuantitySelectorClicked(title, sku, action) {
    let prop = Product.Props.ProductQuantitySelectorClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${title} - ${sku} - ${action}`)
}

export function AddedHeartItem(sku, productName) {
    let prop = Product.Props.AddedProductToFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function RemovedHeartItem(sku, productName) {
    let prop = Product.Props.RemovedProductFromFavorite;
    sendUserAction(Product.EventCategory, prop.EventAction, productName + ' - ' + sku);
}

export function AddToCartClicked(productName, sku, productSize) {
    console.log('Add to cart clicked:', productName, sku, productSize);
    let prop = Product.Props.AddToCartClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}${productSize !== '' ? ` - ${productSize}` : ''}`);
}

export function DetailsClicked(sku, productName) {
    let prop = Product.Props.DetailsClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function ThumbnailClicked(sku, productName) {
    let prop = Product.Props.ThumbnailClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

export function VideoIconClicked(sku, productName) {
    let prop = Product.Props.VideoIconClicked;
    sendUserAction(Product.EventCategory, prop.EventAction, `${productName} - ${sku}`);
}

// Other
export function LogoClicked() {
    let prop = Other.Props.LogoClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WelcomeTipsDismissed() {
    let prop = Other.Props.WelcomeTipsDismissed;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function MusicButton(isOn) {
    let eventLabel = isOn ? 'on' : 'off';
    let prop = Other.Props.MusicButton;
    sendUserAction(Other.EventCategory, prop.EventAction, eventLabel);
}

export function FacebookButtonAnalytics() {
    let prop = Other.Props.FacebookButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function TwitterButtonAnalytics() {
    let prop = Other.Props.TwitterButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function WhatsAppButtonAnalytics() {
    let prop = Other.Props.WhatsAppButton;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ObsessLogo() {
    let prop = Other.Props.ObsessLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function BrandLogo() {
    let prop = Other.Props.BrandLogo;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function Email() {
    let prop = Other.Props.Email;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorIcon() {
    let prop = Other.Props.StoreSelectorIcon;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function StoreSelectorOption(storeName) {
    let prop = Other.Props.StoreSelectorOption;
    sendUserAction(Other.EventCategory, prop.EventAction, storeName);
}

export function CartIconClicked(currentScene) {
    let prop = Other.Props.CartIconClicked;
    console.log(prop.EventAction);
    sendUserAction(Other.EventCategory, prop.EventAction, currentScene);
}

export function TextPopUpButtonClicked(viewName) {
    let prop = Content.Props.TextPopUpButtonClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

export function PoweredByObsessClicked() {
    let prop = Other.Props.PoweredByObsessClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel);
}

export function ClickAnywhereToContinue(screenNumber) {
    let prop = Other.Props.ClickAnywhereToContinue;
    let EventAction = prop.EventAction + screenNumber;
    sendUserAction(Other.EventCategory, EventAction, prop.EventLabel);
}

// Media
export function InSceneVideoClicked(name) {
    let prop = Content.Props.InSceneVideoClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function PopupVideoClicked(name) {
    let prop = Content.Props.PopupVideoClicked;
    let d = {
        "K_IjmegkXuY": "J. Balvin - Ten Cuidado (Pokémon 25 Version)",
        "ojpTpT5i-PI": "Katy Perry - Electric",
        "videoseries?list=OLAK5uy_mPPZrej4zbwrWqNrwDxDvdZgofQ77LwJ0": "Zhu - Remix"
    }
    let eventLabel = name;
    if (name in d){
        eventLabel = d[name];
    }
    sendUserAction(Content.EventCategory, prop.EventAction, eventLabel);
}

export function ImageClicked(name) {
    let prop = Content.Props.ImageClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, name);
}

export function TextClicked(title) {
    let prop = Content.Props.TextClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, title);
}

export function TextPopUpHotSpotClicked(title) {
    console.log('Text pop-up hotspot clicked', title);
    let prop = Content.Props.TextPopUpHotSpotClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, title);
}

export function LinkClicked(targetUrl) {
    let prop = Content.Props.LinkClicked;
    sendUserAction(Content.EventCategory, prop.EventAction, targetUrl);
}

export function PhotoBoothHotSpotClicked(viewName) {
    let prop = Other.Props.PhotoBoothHotSpotClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

export function PhotoBoothSnapButtonClicked(viewName) {
    let prop = Other.Props.PhotoBoothSnapButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

export function PhotoBoothDownloadButtonClicked(viewName) {
    let prop = Other.Props.PhotoBoothDownloadButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

export function PhotoBoothRetakeButtonClicked(viewName) {
    let prop = Other.Props.PhotoBoothRetakeButtonClicked;
    sendUserAction(Other.EventCategory, prop.EventAction, `${storeName} - ${viewName}`);
}

// Page
export function VirtualPageVisited(pageUri) {
    if (!window.gtag) {
        console.log('no gtag');
        const path = storeName + '/' + pageUri;
        missedVirtualPagePaths.push(path);
        return;
    }
    getGAIdAsync()
        .then(analyticsIDsArray => {
            if (analyticsIDsArray.length > 0) {
                analyticsIDsArray.forEach((id) => {
                    window.gtag('config', id, { page_path: '/main/' + pageUri });
                });
            }
        })
        .catch(error => console.error(error));
}

export function CheckoutButtonClicked() {
    let prop = Cart.Props.CheckoutButtonClicked;
    sendUserAction(Cart.EventCategory, prop.EventAction, prop.EventLabel)
}

export function QuantitySelectorClicked(title, sku, action) {
    let prop = Cart.Props.QuantitySelectorClicked;
    sendUserAction(Cart.EventCategory, prop.EventAction, `${title} - ${sku} - ${action}`)
}

export function GifNavigationClick(viewName) {
    let prop = Navigation.Props.GifNavigationClick;
    sendUserAction(Navigation.EventCategory, prop.EventAction, viewName)
}

export function MusicPlayerVolumeAdjust() {
    let prop = Other.Props.MusicPlayerVolumeAdjust;
    sendUserAction(Other.EventCategory, prop.EventAction, prop.EventLabel)
}

export function MusicIconClicked(eventAction) {
    let prop = Custom.Props.MusicIconClicked;
    sendUserAction(Custom.EventCategory, eventAction, prop.EventLabel);
}

export function ArrowPanelClicked(destinationSceneName, direction) {
    let prop = Custom.Props.ArrowPanelClicked;
    const EventAction = direction ? (prop.EventAction + " - " + direction + " clicked") : (prop.EventAction + " clicked");
    sendUserAction(Custom.EventCategory, EventAction, prop.EventLabel + destinationSceneName);
}

export function RightArrowClicked(destinationSceneName) {
    let prop = Custom.Props.RightArrowClicked;
    sendUserAction(Custom.EventCategory, prop.EventAction, prop.EventLabel + destinationSceneName);
}

export function LeftArrowClicked(destinationSceneName) {
    let prop = Custom.Props.LeftArrowClicked;
    sendUserAction(Custom.EventCategory, prop.EventAction, prop.EventLabel + destinationSceneName);
}